import PropTypes from "prop-types";
import React from "react";

import { Button } from "../Button";
import { createClassNameString } from "../utils";

import "./styles.scss";

export const Ellipsis = ({
  centerDisabled,

  centerOnClick,
  className,
  leftDisabled,

  leftOnClick,
  rightDisabled,
  rightOnClick,
  ...props
}) => {
  const leftDisabledClassName = leftDisabled ? "inactive" : "";
  const centerDisabledClassName = centerDisabled ? "inactive" : "";
  const rightDisabledClassName = rightDisabled ? "inactive" : "";

  return (
    <div className={createClassNameString(["apti-CL apti-Ellipsis", className])}>
      <Button
        className={createClassNameString(["apti-Ellipsis--button", leftDisabledClassName])}
        onClick={leftOnClick}
      />
      <Button
        className={createClassNameString(["apti-Ellipsis--button", centerDisabledClassName])}
        onClick={centerOnClick}
      />
      <Button
        className={createClassNameString(["apti-Ellipsis--button", rightDisabledClassName])}
        onClick={rightOnClick}
      />
    </div>
  );
};

Ellipsis.propTypes = {
  centerDisabled: PropTypes.bool,
  centerOnClick: PropTypes.func,
  className: PropTypes.string,
  leftDisabled: PropTypes.bool,
  leftOnClick: PropTypes.func,
  rightDisabled: PropTypes.bool,
  rightOnClick: PropTypes.func,
};

Ellipsis.defaultProps = {
  centerDisabled: false,
  centerOnClick: () => {},
  className: undefined,
  leftDisabled: false,
  leftOnClick: () => {},
  rightDisabled: false,
  rightOnClick: () => {},
};
